import { createSelector } from 'reselect';
import { getFavourites } from './get-favourites';

const EMPTY_RECOMMENDED_PRODUCTS = [];

export const getFavouritesRecommendedProducts = createSelector(
  [getFavourites],
  favourites => favourites.recommendations || EMPTY_RECOMMENDED_PRODUCTS,
);
